import { useLocation } from "react-router-dom";
import { usePageTitle } from "../hooks/usePageTitle";
import { useDocumentSeo } from "../hooks/useDocumentSeo";
import { useTranslation } from "../i18n";
import Sidebar from "./Sidebar";
import AdminCopilotRuntime from "../components/admin/copilot/AdminCopilotRuntime";

function DashboardTitle() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const titleKey =
    pathname.endsWith("/products/categories")
      ? "categories.title"
      : pathname.includes("/products/list/new")
        ? "products.create"
        : /\/products\/list\/[^/]+\/edit$/.test(pathname)
          ? "products.edit"
          : pathname.endsWith("/products/list")
            ? "products.title"
            : pathname.endsWith("/products/price-rules")
              ? "priceRules.title"
              : pathname.endsWith("/products/tags")
                ? "tags.title"
                : pathname.endsWith("/products/variant-attributes")
                  ? "variantAttributes.title"
                  : pathname.endsWith("/users-rules/users")
                    ? "users.title"
                    : pathname.includes("/users-rules/rules/new")
                      ? "roles.create"
                      : /\/users-rules\/rules\/[^/]+\/edit$/.test(pathname)
                        ? "roles.edit"
                        : pathname.endsWith("/users-rules/rules")
                          ? "roles.title"
                          : pathname.endsWith("/orders")
                            ? "commerce.admin.orders"
                            : pathname.includes("/orders/")
                              ? "commerce.admin.order"
                              : pathname.endsWith("/commerce/promotions")
                                ? "promotions.title"
                                : pathname.endsWith("/commerce/customer-risk")
                                  ? "commerce.admin.risk"
                                  : pathname.endsWith("/commerce/reviews")
                                    ? "commerce.admin.reviews"
                                    : pathname.endsWith("/commerce/inventory")
                                      ? "commerce.admin.inventory"
                                      : pathname.endsWith("/commerce/reports")
                                        ? "commerce.admin.reports"
                                        : pathname.endsWith("/settings/appearance")
                                          ? "theme.editor.title"
                                          : pathname.endsWith("/settings/banners")
                                            ? "banners.title"
                                            : pathname.endsWith("/settings/commerce")
                                              ? "commerce.admin.settings"
                                              : pathname.endsWith("/settings/company")
                                                ? "settings.company.title"
                                                : pathname.endsWith("/contact-inquiries")
                                                  ? "contactInquiries.title"
                                                  : pathname.endsWith("/website-users")
                                                    ? "websiteUsers.title"
                                                    : /\/website-users\/[^/]+$/.test(pathname)
                                                      ? "websiteUsers.detailsTitle"
                                                    : pathname.endsWith("/website/homepage")
                                                      ? "website.nav.home"
                                                      : pathname.endsWith("/website/testimonials")
                                                        ? "testimonials.title"
                                                        : "dashboard.overview.title";

  usePageTitle(t(titleKey));
  useDocumentSeo({ robots: "noindex,nofollow" });
  return null;
}

/**
 * Root layout component
 * Wraps all pages with common layout (header, sidebar with nav + page content).
 */
function RootLayout() {
  return (
    <>
      <DashboardTitle />
      <Sidebar />
      <AdminCopilotRuntime />
    </>
  );
}

export default RootLayout;
